/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'basic/medium-brightness-1214363': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M3 11a1 1 0 101 1 1 1 0 00-1-1zm1.93 6.66a1 1 0 101.41 0 1 1 0 00-1.41 0zM6.34 6.34a1 1 0 10-1.41 0 1 1 0 001.41 0zM12 4a1 1 0 10-1-1 1 1 0 001 1zm5.66 13.66a1 1 0 101.41 0 1 1 0 00-1.41 0zM21 11a1 1 0 101 1 1 1 0 00-1-1zm-3.34-6.07a1 1 0 101.41 0 1 1 0 00-1.41 0zM12 20a1 1 0 101 1 1 1 0 00-1-1zm0-14a6 6 0 106 6 6 6 0 00-6-6zm0 10a4 4 0 114-4 4 4 0 01-4 4z"/>'
  }
})
